import { render, staticRenderFns } from "./DetailsEleenaBox.vue?vue&type=template&id=3bda6fb1"
import script from "./DetailsEleenaBox.vue?vue&type=script&lang=ts"
export * from "./DetailsEleenaBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports